import { type SearchCategory, isSearchCategory} from '@mimir/common/dto/searchModels';
import { ItemType } from '@mimir/common/dto/itemTypes';
import { MediaAvailabilityStatus } from '@mimir/common/dto/mediaDtos';
import { reactive } from '../compat/vueCompat';
import cloneDeep from 'lodash/cloneDeep';

export const MediaTypes = [ItemType.VIDEO, ItemType.IMAGE, ItemType.AUDIO, ItemType.FILE, ItemType.CLIP_LIST];
export const NonMediaTypes = [MediaAvailabilityStatus.STREAMING, ItemType.FOLDER, ItemType.PERSON];
export const MEDIA_FILTER = 'media';
export const ALL_FILTER = 'all';

export type SearchCategoryUI = SearchCategory | typeof MEDIA_FILTER | typeof ALL_FILTER;

interface FilterState {
  radioFilter: SearchCategoryUI;
  selectedMediaTypes: SearchCategory[];
}

export const filters: FilterState = reactive({
  radioFilter: MEDIA_FILTER,
  selectedMediaTypes: cloneDeep(MediaTypes),
});

export const setRadioFilter = (filter: SearchCategoryUI) => {
  filters.radioFilter = filter;
};

export const setSelectedMediaTypes = (type: SearchCategory | SearchCategory []) => {
  if (Array.isArray(type)) {
    filters.selectedMediaTypes = cloneDeep(type);
  } else {
    filters.selectedMediaTypes.push(type);
  }
};

export const clearOrRemoveSelectedMediaTypes = (type?: SearchCategoryUI) => {
  if (!type) return filters.selectedMediaTypes = [];
  if (!isSearchCategory(type)) return;
  const index = filters.selectedMediaTypes.indexOf(type);
  if (index !== -1) {
    filters.selectedMediaTypes.splice(index, 1);
  }
};
